export class AreaAccountGoogleModel  {
    public phone: string; 
    public notes: string; 
}
